export class AppBarConfig {
    visible: boolean;
    parts: any;
    classes: string[];
} 